import pl from './lang/pl.json';

export default pl.translation;
